// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.coin-flip {
  display: inline-block;
  perspective: 1000px; /* Adiciona profundidade ao efeito 3D */
  animation: pop-in 0.5s ease-out forwards;
  position: relative; /* Necessário para o pseudo-elemento */
}

.coin-flip::after {
  content: "";
  position: absolute;
  top: -110%;
  left: -210%;
  width: 200px;
  height: 200px;
  opacity: 0;
  transform: rotate(30deg);
  
  background: rgba(255, 255, 255, 0.13);
  background: linear-gradient(
    to right, 
    rgba(255, 255, 255, 0.13) 0%,
    rgba(255, 255, 255, 0.13) 77%,
    rgba(255, 255, 255, 0.5) 92%,
    rgba(255, 255, 255, 0.0) 100%
  );
  animation: shineAnimation 5s ease-in-out infinite;
}
@keyframes shineAnimation {
  0% {
    opacity: 0;
    top: -110%;
    left: -210%;
  }
  50% {
    opacity: 1;
    top: -30%;
    left: -30%;
  }
  100% {
    opacity: 0;
    top: 50%;
    left: 70%;
  }
}

.coin-flip img {
  width: 100px;
  height: 100px;
  border-radius: 50%; /* Torna a imagem redonda */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  animation: coin-spin 0.75s linear forwards; /* Dura 0.75 segundos e mantém o estado final */
  transform-origin: center; /* Define o ponto de rotação */
}

/* Animação de giro */
@keyframes coin-spin {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}

/* Check aparece */
@keyframes pop-in {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB,EAAE,uCAAuC;EAC5D,wCAAwC;EACxC,kBAAkB,EAAE,sCAAsC;AAC5D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;EACV,wBAAwB;;EAExB,qCAAqC;EACrC;;;;;;GAMC;EACD,iDAAiD;AACnD;AACA;EACE;IACE,UAAU;IACV,UAAU;IACV,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;IACT,UAAU;EACZ;EACA;IACE,UAAU;IACV,QAAQ;IACR,SAAS;EACX;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB,EAAE,2BAA2B;EAC/C,wCAAwC;EACxC,0CAA0C,EAAE,+CAA+C;EAC3F,wBAAwB,EAAE,8BAA8B;AAC1D;;AAEA,qBAAqB;AACrB;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.coin-flip {\n  display: inline-block;\n  perspective: 1000px; /* Adiciona profundidade ao efeito 3D */\n  animation: pop-in 0.5s ease-out forwards;\n  position: relative; /* Necessário para o pseudo-elemento */\n}\n\n.coin-flip::after {\n  content: \"\";\n  position: absolute;\n  top: -110%;\n  left: -210%;\n  width: 200px;\n  height: 200px;\n  opacity: 0;\n  transform: rotate(30deg);\n  \n  background: rgba(255, 255, 255, 0.13);\n  background: linear-gradient(\n    to right, \n    rgba(255, 255, 255, 0.13) 0%,\n    rgba(255, 255, 255, 0.13) 77%,\n    rgba(255, 255, 255, 0.5) 92%,\n    rgba(255, 255, 255, 0.0) 100%\n  );\n  animation: shineAnimation 5s ease-in-out infinite;\n}\n@keyframes shineAnimation {\n  0% {\n    opacity: 0;\n    top: -110%;\n    left: -210%;\n  }\n  50% {\n    opacity: 1;\n    top: -30%;\n    left: -30%;\n  }\n  100% {\n    opacity: 0;\n    top: 50%;\n    left: 70%;\n  }\n}\n\n.coin-flip img {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%; /* Torna a imagem redonda */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  animation: coin-spin 0.75s linear forwards; /* Dura 0.75 segundos e mantém o estado final */\n  transform-origin: center; /* Define o ponto de rotação */\n}\n\n/* Animação de giro */\n@keyframes coin-spin {\n  0% {\n    transform: rotateY(0deg);\n  }\n  100% {\n    transform: rotateY(360deg);\n  }\n}\n\n/* Check aparece */\n@keyframes pop-in {\n  0% {\n    transform: scale(0.5);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
